"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Requirejs = void 0;

var json_websiteConfig_1 = __importDefault(require("json!websiteConfig"));

var maishu_ui_toolkit_1 = require("maishu-ui-toolkit");

var maishu_toolkit_1 = require("maishu-toolkit");

var errors_1 = require("./errors");

var contextName = json_websiteConfig_1.default.requirejs != null ? json_websiteConfig_1.default.requirejs.context : null;
/** 对 requirejs 进行封装，方便使用 */

var Requirejs = /*#__PURE__*/function () {
  function Requirejs() {
    _classCallCheck(this, Requirejs);
  }

  _createClass(Requirejs, null, [{
    key: "loadjs",
    value: function loadjs(modules) {
      return new Promise(function (resolove, reject) {
        // 直接使用 requirejs.config webpack 打包会去掉 requirejs，原因不明
        var req = window["requirejs"].config({
          context: contextName
        });
        req(modules, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          resolove(args);
        }, function (err) {
          console.log(err);
          reject(err);
        });
      });
    }
  }, {
    key: "loadLess",
    value: function loadLess(stationPath) {
      maishu_ui_toolkit_1.Less.renderByRequireJS(stationPath, {
        contextName: contextName
      });
    }
  }, {
    key: "websitePath",
    value: function websitePath(stationPath) {
      if (!stationPath) throw errors_1.errors.argumentNull("stationPath");
      if (typeof stationPath != "string") throw errors_1.errors.argumentTypeIncorrect("stationPath", "string");
      var contexts = requirejs.exec("contexts");
      var context = contexts[contextName];

      if (context != null && context.config != null && context.config.baseUrl != null) {
        return maishu_toolkit_1.pathConcat(context.config.baseUrl, stationPath);
      }

      return stationPath;
    }
  }]);

  return Requirejs;
}();

exports.Requirejs = Requirejs;
